import React from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleRatedFeaturesListItem.module.scss';

/**
 * Linear interpolation between values X and Y.
 * @param {number} x - value X
 * @param {number} y - value Y
 * @param {number} a - alpha blending value [0, 1]
 * @returns {number} - interpolated value
 */
const lerp = (x, y, a) => x * (1 - a) + y * a;

const ArticleRatedFeaturesListItem = (props) => {
  const { text, score, maxScore } = props;

  const progress = (Math.max(score, 0) / Math.max(maxScore, 1)) * 100;

  return (
    <div className={style.rateListItem}>
      <div className={style.rateListTitle}>{text}</div>
      <div className={style.rateBar}>
        <div
          className={style.rateBarFilled}
          style={{ width: `${progress}%` }}
        />
        <div
          className={style.rateBarCircle}
          style={{
            left: `${progress}%`,
            transform: `translate(${lerp(0, -100, progress / 100)}%, -50%)`,
          }}
        >
          <div className={style.rateBarScore}>{score}</div>
        </div>
      </div>
    </div>
  );
};

ArticleRatedFeaturesListItem.propTypes = {
  text: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  maxScore: PropTypes.number.isRequired,
};

export default ArticleRatedFeaturesListItem;
